import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { altonConfig } from "./data";

export default function AltonPage() {
  return <CityPageTemplate config={altonConfig} />;
}